import { memo, ReactNode, PropsWithChildren, FC } from 'react';

import Text from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import FormatMoney from 'src/components/FormatMoney';
import { PriceCartProductType } from 'src/models/price/priceCart';
import { NON_BREAKING_SPACE } from 'src/utils/constants/symbols';

import getBrandedVacancyTemplateCount from 'src/components/Price/PriceCart/PriceCartProduct/Branding/getBrandedVacancyTemplateCount';
import RemoveButton from 'src/components/Price/PriceCart/PriceCartProduct/RemoveButton';

import styles from './price-cart-item-zp.less';

interface PriceCartItemZPProps {
    dataQa?: string;
    product: PriceCartProductType;
    title: ReactNode;
}

const PriceCartItemZP: FC<PriceCartItemZPProps & PropsWithChildren> = ({ children, dataQa, product, title }) => {
    const brandedVacancyTemplateCount = getBrandedVacancyTemplateCount(product);
    const hasBrandedVacancyTemplate = !!brandedVacancyTemplateCount;

    return (
        <>
            <div data-qa={dataQa}>
                <div className={styles.title}>
                    <div className={styles.titleText}>{title}</div>
                    <RemoveButton
                        itemId={product.itemId}
                        onClick={() => {
                            if (hasBrandedVacancyTemplate) {
                                window.dispatchEvent(new CustomEvent('HH-Branding-Price-Backet-Remove-Item'));
                            }
                        }}
                    />
                </div>
                <Text>{children}</Text>
                <VSpacing base={3} />

                <Text Element="p" data-qa="cart-item__total-cost">
                    <FormatMoney
                        inCents={true}
                        currency={product.currency}
                        render={(amount, currencyNode) => (
                            <>
                                <span data-qa="money__amount">{amount}</span>
                                {NON_BREAKING_SPACE}
                                <span data-qa="money__currency">{currencyNode}</span>
                            </>
                        )}
                    >
                        {product.price}
                    </FormatMoney>
                </Text>
            </div>
        </>
    );
};

export default memo(PriceCartItemZP);
